import * as bi from 'react-bootstrap-icons';
import { IClientTripBrief } from '@bustickus/models-client';
import { Flex } from 'components';
import { Icon } from 'shared/components';
import { dateFormat } from 'common/helpers';
import './style.scss';

interface IProps {
  trip: IClientTripBrief;
  onClick?: (trip: IClientTripBrief) => void;
  selected?: boolean;
}

function BackTripCard(props: IProps) {
  const dDateString = dateFormat(props.trip.departure?.departureDate, 'DD.MM.YYYY HH:mm');
  const aDateString = dateFormat(props.trip.arrival?.arrivalDate, 'DD.MM.YYYY HH:mm');

  return (
    <Flex
      justifyContent='space-between'
      className='back-trip-card-Masj'
      onClick={() => props.onClick?.(props.trip)}
    >
      <Flex
        direction='column'
        gap={10}
      >
        <Flex
          direction='column'
          gap={5}
        >
          <Flex justifyContent='space-between'>
            <Flex gap={5}>
              <div>
                <Icon className='icon-KahYsa'>
                  <bi.Clock />
                </Icon>
              </div>

              <Flex gap={5}>
                <Flex direction='column'>
                  <span>{dDateString.datetime}</span>
                  <span className='tz-Kpj3'>({dDateString.mskTimezone})</span>
                </Flex>
                <span>—</span>
                <Flex direction='column'>
                  <span>{aDateString.datetime}</span>
                  <span className='tz-Kpj3'>({aDateString.mskTimezone})</span>
                </Flex>
              </Flex>
            </Flex>
          </Flex>

          <Flex gap={10}>
            {props.trip.number && (
              <Flex gap={5}>
                <Icon className='icon-KahYsa'>
                  <bi.BusFront />
                </Icon>
                <span>{props.trip.number}</span>
              </Flex>
            )}

            <Flex gap={5}>
              <Icon className='icon-KahYsa'>
                <bi.Coin />
              </Icon>
              <span>{props.trip.price} ₽</span>
            </Flex>
            <Flex gap={5}>
              <Icon className='icon-KahYsa'>
                <bi.Ticket />
              </Icon>
              <span>{props.trip.tickets} билетов</span>
            </Flex>
          </Flex>
        </Flex>
        <div className='back-carrier-title-IKah'>{props.trip.carrierName}</div>
      </Flex>

      <Icon className={props.selected ? 'selectable-icon-mkauA icon-KahYsa' : 'selectable-icon-mkauA icon-02-Mnahs'}>
        {props.selected && <bi.Check2Circle />}
        {!props.selected && <bi.Circle />}
      </Icon>
    </Flex>
  );
}

export default BackTripCard;
